import ExternalLink from '../atoms/ExternalLink';
import Heading from '../atoms/Heading';
import LinkButton from '../atoms/LinkButton';
import PaymentTable from '../templates/PaymentTable';

type Props = {
  anchor: string;
};

/**
 * 支払い方法の確認と変更導線をまとめて表示する情報セクション。
 * 契約情報から自然に決済変更へ進める入口を残し、問い合わせ導線も同じ場所に集約する。
 */
const PaymentInfo = ({ anchor }: Props) => {
  return (
    <div className='m-box-02' id={anchor}>
      <div className='m-box-02__inner'>
        <Heading as='h2' icon='payment'>
          お支払い情報
        </Heading>

        {/* 実際の請求手段や状態表示はテンプレート側へ寄せ、この部品は導線整理に専念させる。 */}
        <PaymentTable />

        <div className='m-linkTxt' style={{ marginTop: '20px' }}>
          {/* 手続き前に自己解決できるよう、サポート FAQ を変更導線の手前に置く。 */}
          <ExternalLink href='https://support.sonynetwork.co.jp/faqsupport/nuro/web/knowledge6921.html'>
            お支払い方法の登録・変更について知りたい（NURO 光 サポート）
          </ExternalLink>
        </div>

        <div className='m-button align-center'>
          {/* FAQ で解決しない場合にそのまま登録変更へ進めるよう、最終導線を隣接配置する。 */}
          <LinkButton variant='secondary' href='/contract/payment'>
            お支払い情報の登録・変更
          </LinkButton>
        </div>
      </div>
    </div>
  );
};

export default PaymentInfo;
